import { createSlice } from "@reduxjs/toolkit";
import {
  getReceivingNotes,
  getSendingNoteFromSchool,
} from "../services/notes_services";
// ----------------------------------------------------------------------

const slice = createSlice({
  name: "notes",

  initialState: {
    isLoadingReceivingNotesFromParent: false,
    receivingNotesFromParent: [],
    isLoadingGetSendingNoteFromSchool: false,
    sendingNoteFromSchool: false,
    sendingNotesPageNumber: 1,
  },

  reducers: {
    setSendingNotesPageNumber: (state, action) => {
      state.sendingNotesPageNumber = action.payload;
    },
  },

  extraReducers: {
    // ==> get Reciving Note From Parents
    [getReceivingNotes.fulfilled]: (state, action) => {
      state.isLoadingReceivingNotesFromParent = false;
      state.receivingNotesFromParent = action.payload.data;
    },
    [getReceivingNotes.rejected]: (state, action) => {
      state.isLoadingReceivingNotesFromParent = false;
    },
    [getReceivingNotes.pending]: (state) => {
      state.isLoadingReceivingNotesFromParent = true;
    },

    // ==> get Sending Note From School
    [getSendingNoteFromSchool.fulfilled]: (state, action) => {
      state.isLoadingGetSendingNoteFromSchool = false;
      state.sendingNoteFromSchool = action.payload.data;
    },
    [getSendingNoteFromSchool.rejected]: (state, action) => {
      state.isLoadingGetSendingNoteFromSchool = false;
    },
    [getSendingNoteFromSchool.pending]: (state) => {
      state.isLoadingGetSendingNoteFromSchool = true;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { setSendingNotesPageNumber } = slice.actions;
